import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/antibodies_analytics.py
export const ANTIBODIES_ANALYTICS_ACTIONS = {
  // Antibody format events
  CLICKED_CREATE_NEW_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'clicked_create_new_format',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TYPED_CUSTOM_FORMAT_DISPLAY_NAME: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'typed_custom_format_display_name',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TYPED_CUSTOM_FORMAT_VERITAS_NAME: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'typed_custom_format_veritas_name',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREVIEWED_VERITAS_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'previewed_veritas_format',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VERITAS_FORMAT_PREVIEW_RETURNED_ERRORS: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'veritas_format_preview_returned_errors',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_ANTIBODY_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'created_antibody_format',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_ANTIBODY_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'updated_antibody_format',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_ANTIBODY_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'archived_antibody_format',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  READ_ANTIBODY_FORMAT_VIA_API: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'read_antibody_format_via_api',
    actionCategory: ACTION_CATEGORY.READ,
  },
  READ_ANTIBODY_COMPONENT_VIA_API: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'read_antibody_component_via_api',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_ANTIBODY_FORMAT_ON_SCHEMA: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'selected_antibody_format_on_schema',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_ANTIBODY_SCHEMA: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'created_antibody_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SELECTED_ANTIBODY_COMPONENT_SSI_ON_SCHEMA: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'selected_antibody_component_ssi_on_schema',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_ANTIBODY_ENTITY: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'opened_antibody_entity',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_ANTIBODY_COMPONENT_ENTITY: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'opened_antibody_component_entity',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_COMPONENT_IN_ANTIBODY_MAP: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'clicked_component_in_antibody_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_COMPONENT_CHIP_IN_ANTIBODY_MAP: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'clicked_component_chip_in_antibody_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXPANDED_COMPONENT_PREVIEW: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'expanded_component_preview',
    actionCategory: ACTION_CATEGORY.READ,
  },
  COLLAPSED_COMPONENT_PREVIEW: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'collapsed_component_preview',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_GERMLINE: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'selected_germline',
    actionCategory: ACTION_CATEGORY.READ,
  },
  NDC_PIPELINE_SUCCESS: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'ndc_pipeline_success',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NDC_PIPELINE_FAILED: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'ndc_pipeline_failed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NDC_PIPELINE_SUBMIT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'ndc_pipeline_submit',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_ANTIBODIES: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'created_antibodies',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_ANTIBODIES: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'updated_antibodies',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  REGISTERED_ANTIBODIES: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'registered_antibodies',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  READ_ANTIBODY_VIA_API: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'read_antibody_via_api',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_SCHEMA_MIGRATION_PREVIEW_MODAL: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'opened_schema_migration_preview_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MAPPED_FIELD_FOR_SCHEMA_MIGRATION: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'mapped_field_for_schema_migration',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SCHEMA_MIGRATION_BLOCKED_BY_FIELD_CONFLICT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'schema_migration_blocked_by_field_conflict',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INTERACTED_PROTEIN_STRUCTURE_VIEWER: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'protein_structure_viewer_interaction',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_PROTEIN_STRUCTURE: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'protein_structure_download',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
